<template>
  <div class="devicelist container" ref="box">
    <div class="search-box" ref="topBox">
      <!-- <el-input class="common" v-model="keyWords.deviceName" autocomplete="off" placeholder="设备名称" @keyup.enter.native="serachData" width="100"></el-input>

      <el-button @click="handleSearch" type="primary"
        class="common"
        icon="el-icon-search">搜索</el-button> -->
      <el-button
        @click="handleDown"
        :loading="mLoading"
        class="common"
        type="primary"
        icon="el-icon-download" plain>模板下载</el-button>
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="`${baseUrlAddr}/front/device/transmission/addAll`"
        :on-success="handleSuccess"
        :on-change="handleChangeUpload"
        :on-progress="handleProgress"
        :limit="1"
        :data="uploadParams"
        accept=".xls,.xlsx"
        :show-file-list="false">
        <el-button
          @click="handleInFile"
          :loading="importLoading"
          class="common"
          type="success"
          icon="el-icon-upload2" plain>{{importLoading ? '设备导入中...' : '设备导入'}}</el-button>
        </el-upload>
      <!-- <el-popconfirm :title="`即将导出${pagination.total}条设备`" @confirm="handleOutFile">
        <el-button
          slot="reference"
          :loading="exportLoading"
          class="common"
          type="success"
          icon="el-icon-download" plain>一键导出</el-button>
      </el-popconfirm> -->
      <el-button
        type="primary"
        @click='handleShowDetails("add")'
        class="common"
        icon="el-icon-plus">新增</el-button>
    </div>
    <div class="table-box">
      <border-table
        :loading="tableLoading"
        :tableData="dataList"
        :tableHeights="tableHeight"
        :pageSizes="[10, 20, 50]"
        :pages="pagination"
        :total="pagination.total"
        :current-page="pagination.page"
        @currentChange="handleRoleCurrentChange"
        @selectionChange="handleSelectionChange"
        @sizeChange="handleRoleSizeChange"
        isAll="all">
        <!-- <el-table-column type="selection" width="50"></el-table-column> -->
        <el-table-column prop="name" label="设备名称" show-overflow-tooltip />
        <el-table-column prop="code" label="设备编码" />
        <el-table-column prop="address" label="位置" show-overflow-tooltip />
        <el-table-column prop="" label="报警状态">
          <template slot-scope="scope">
            <el-tag :class="`${scope.row.isAlarm === 'true' ? 'red':'blue'}`" size="small">{{scope.row.isAlarm === 'true' ? '已报警' : '未报警'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
        <el-table-column prop="" label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-document" @click='handleShowDetails("edit", scope.row)'>编辑</el-button>
            <el-button type="text" class="del" icon="el-icon-delete" @click='handleDelete(scope.row)'>删除</el-button>
          </template>
        </el-table-column>
      </border-table>
    </div>
     <!-- 新增编辑 -->
    <el-drawer
      :title="type == 'add' ? '新增' : '编辑'"
      :visible.sync="isDetailsShow"
      size="480px"
      @close="handleClose">
      <el-form
        :model="dataDetail"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="100px">
        <el-form-item label="设备名称" prop="name">
          <el-input v-model="dataDetail.name"></el-input>
        </el-form-item>
        <el-form-item label="设备编码" prop="code">
          <el-input v-model="dataDetail.code"></el-input>
        </el-form-item>
        <el-form-item label="位置" prop="address">
          <el-input v-model="dataDetail.address"></el-input>
        </el-form-item>
      </el-form>
      <div class="drawerFoot">
        <el-button type="info" plain @click="isShowDrawer = false">取消</el-button>
        <el-button type="primary" plain @click="confirmHandle" :loading="loading">{{loading ? '提交中' : '提交'}}</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import BorderTable from "@/components/common/BorderTableDevice";
// import { formatTime } from '@/utils/validate'
export default {
  components: {
    BorderTable
  },
  props: {
    parentDeviceId: {
      type: [Number, String],
      default: () => {
        return null
      },
    },
  },
  data () {
    return {
      keyWords: {
        deviceName: '',
      },
      tableHeight: '100%',
      dataList: [],
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      isDetailsShow: false,
      dataDetail: {
        name: '',
        code: '',
        address: '',
      },
      tableLoading: false,
      loading: false,
      options: [],
      options2: [],
      deviceTypeList: [],
      rules: {
        name: [{ required: true, message: '请填写设备名称', trigger: 'blur' }],
        code: [{ required: true, message: '请填写设备编码', trigger: 'blur' }],
        address: [{ required: true, message: '请填写位置', trigger: 'blur' }],
      },
      type: 'add',
      checkDatas: [],
      mLoading: false,
      inputVisible: false,
      importLoading: false,
      exportLoading: false,
      uploadParams: {
        deviceId: ''
      },
    }
  },
  created () {},
  mounted () {
    this.initData()
  },
  methods: {
    // 表格当前页变化时
    handleRoleCurrentChange (val) {
      this.pagination.currentPage = val
      this.initData()
    },
    // 表格展示条数变化时
    handleRoleSizeChange (val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.initData()
    },
    // 表格多选赋值
    handleSelectionChange (data) {
      console.log(data)
      this.checkDatas = data
    },
    handleSearch () {
      this.pagination.currentPage = 1
      this.initData()
    },
    // 请求列表数据
    async initData () {
      this.selectData = {}
      // let { deviceName } = this.keyWords
      let parentDeviceId = this.parentDeviceId
      let { currentPage, pageSize } = this.pagination
      let params = {
        // deviceName,
        deviceId: parentDeviceId,
        page: currentPage,
        pageSize
      }

      this.tableLoading = true
      let { code, msg, data, total } = await this.request.get('/front/device/transmission/sonquery', params)
      this.tableLoading = false

      if (code != 200) return this.$message({ type: 'warning', message: msg })

      this.dataList = data
      this.pagination.total = total
    },
    // 显示编辑弹窗
    handleShowDetails (type, row) {
      this.isDetailsShow = true
      this.type = type
      if (type == 'add') {
        Object.keys(this.dataDetail).forEach(key => this.dataDetail[key] = '')
        this.dataDetail.deviceId = this.parentDeviceId
      } else {
        this.dataDetail = { ...row }
      }
    },
    // 提交新增/修改
    confirmHandle () {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let params = { ...this.dataDetail, imei: this.dataDetail.code }
          this.loading = true
          let { code, msg } = await this.request.get('/front/device/transmission/addoredit', params)
          this.loading = false

          if (code == 200) {
            this.isDetailsShow = false
            this.pagination.currentPage = 1
            this.initData()
            this.$message({ type: 'success', message: '提交成功！' })
          } else {
            this.$message({ type: 'warning', message: msg })
          }
        }
      })
    },
    // 删除设备
    handleDelete ({ id }) {
      this.$alert('此操作将永久删除该设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        callback: async action => {
          if (action == 'confirm') {
            let { code } = await this.request.get(`/front/device/transmission/del/${id}`)
            if (code == 200) {
              this.pagination.currentPage = 1
              this.initData()
              this.$message({ type: 'success', message: '删除成功!' })
            } else {
              this.$message({ type: 'success', message: '删除失败!' })
            }
          } else {
            this.$message({ type: 'info', message: '已取消删除' })
          }
        }
      })
    },
    // 关闭弹窗
    handleClose () {
      this.isDetailsShow = false
    },
    // 导入文件1
    handleInFile () {
      // console.log(1313, this.parentDeviceId)
      this.uploadParams.deviceId = this.parentDeviceId
    },
    // 导入文件-进度
    handleProgress (event, file, fileList) {
      this.importLoading = true
    },
    // 导入文件-进行中
    handleChangeUpload (file, fileList) {
      if (file.status === 'success') {
        this.importLoading = false
        if (file.response.code === 200) {
          this.inputVisible = false
          this.pagination.currentPage = 1
          this.initData()
          this.msg.success(file.response.msg)
        } else {
          this.msg.error(file.response.msg)
        }
      } else if (file.status === 'error') {
        this.importLoading = false
        this.msg.error('上传失败，请重试！')
      }
    },
    // 导入文件-成功
    handleSuccess (res) {
      // console.log(123, res)
      this.$refs.upload.clearFiles()
    },
    // 导出文件
    handleOutFile () {
      let deviceName = this.keyWords.deviceName
      let parentDeviceId = this.parentDeviceId
      this.exportLoading = true
      this.$axios.get(`${this.baseUrlAddr}/front/device/trans/subset/download?parentDeviceId=${parentDeviceId}&deviceName=${deviceName}`, {
        headers: { 'Content-Type': 'application/json,charset=utf-8' },
        responseType: 'arraybuffer', // 二进制流
      }).then(res => {
        this.exportLoading = false
        if (res.status === 200) {
          const blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel,charset=utf-8',
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = `用传中的设备列表${new Date().getTime()}.xlsx`
          link.click()
        } else {
          this.msg.error('下载失败')
        }
      }).catch(() => {
        this.exportLoading = false
      })
    },
    handleDown () {
      this.mLoading = true
      this.$axios.get(`${this.baseUrlAddr}/front/device/transmission/deviceTransUploadTemplate`, {
        headers: { 'Content-Type': 'application/json,charset=utf-8' },
        responseType: 'arraybuffer', // 二进制流
      }).then(res => {
        this.mLoading = false
        if (res.status === 200) {
          const blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel,charset=utf-8',
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = '导入模板.xlsx'
          link.click()
        } else {
          this.msg.error('下载失败')
        }
      }).catch(e => {
        this.mLoading = false
        console.error(e)
        this.msg.error('下载失败')
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.devicelist {
  &.container {
    height: 100%;
    // padding: 0 10px;
    .search-box {
      // background-color: rgba(47, 134, 226, 0.1);
      border-radius: 5px;
      // min-height: 80px;
      padding: 10px 0 0;
      .common {
        display: inline-block;
        margin-left: 10px;
        margin-bottom: 10px;
      }
      ::v-deep  .common.el-input {
        width: 200px;
      }
      ::v-deep .el-input__inner {
        width: 200px;
        height: 40px;
        // border: 1px solid rgba($color: #fff, $alpha: 0.12);
        border-radius: 3px;
        // color: #fff;
        // background-color: transparent;
      }
    }
    .table-box {
      height: calc(100% - 100px);
      border-radius: 5px;
      position: relative;
      margin-top: 10px;
      padding-bottom: 35px;
      .del {
        color: #FF001D;
      }
    }
  }
  .drawerFoot {
    border-top: 1px solid #D7DAE2;
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 70px;
    line-height: 70px;
    text-align: right;
    padding-right: 30px;
    box-sizing: border-box;
    box-shadow: 4px 0 4px 2px rgba(144,147,153,.2);
  }
  .upload-demo {
    display: inline-block;
  }
}
</style>
<style lang="scss">
  .devicelist {
    .tableContainer {
      height: calc(100% - 20px) !important;
      .tableBox {
        height: 100% !important;
      }
    }
    .in-box {
      .el-input {
        width: 460px;
      }
    }
  }
</style>
